(async function ($) {

  if (!$('.bis-wrapper')) return;

  function init($) {

    if (!window.hasOwnProperty("BIS")) {
      return new Promise(resolve => setTimeout(resolve, 300))
        .then(() => init($))
    }

    let $bisBtn;
    let $bisPopupCloseBtn;
    let $bisPopup;
    let $bisPopupContent;
    let $bisPopupForm;

    const notificationCallback = function(data) {
      const $successBox = $('.form-success');
      const $errorBox = $('.form-error');
      $successBox.addClass('hide');
      $errorBox.addClass('hide');

      if (data.status == 'OK') {
        $successBox.removeClass('hide');
        return;
      }

      $errorBox.removeClass('hide');
    }

    function _handleFormSubmit(e) {
      e.preventDefault();

      const email = $('#CustomerEmail').val();
      const productId = _BISConfig.product.id;
      const variantId = _BISConfig.product.variants[0].id;

      console.log(email, productId, variantId);

      BIS.create(email, variantId, productId).then(notificationCallback);
    }
  
    function _handleBisBtnClick() {
      $bisPopup.removeClass('bis-popup-hidden');
    }
  
    function _handleBisPopupClick(e) {
      _handleBisPopupCloseBtnClick(e); // click outside popup
    }
  
    function _handleBisPopupContentClick(e) {
      e.stopImmediatePropagation(); // click inside popup
    }
  
    function _handleBisPopupCloseBtnClick() {
      $bisPopup.addClass('bis-popup-hidden');
    }
  
    $bisBtn = $(".bis-btn");
    $bisBtn.click(_handleBisBtnClick);
  
    $bisPopup = $(".bis-popup");
    $bisPopup.click(_handleBisPopupClick);
  
    $bisPopupContent = $(".bis-popup-content");
    $bisPopupContent.click(_handleBisPopupContentClick);
  
    $bisPopupCloseBtn = $(".bis-popup-close-btn");
    $bisPopupCloseBtn.click(_handleBisPopupCloseBtnClick);

    $bisPopupForm = $(".bis-popup-form");
    $bisPopupForm.submit(_handleFormSubmit);
  }

  init($);

})(pipelineVendor.$);